import { styled } from '@mui/system';
import { Box, Paper } from '@mui/material';
import { figmaLetterSpacing } from '../../../../../ui/utils';
import { SectionHeading } from '../../../../../ui/typography';

export const SectionWrapper = styled(Box)(({ theme }) => ({
  maxWidth: '1100px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(6),
  },
}));

export const ImageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '550px',
  maxHeight: '700px',
  justifyContent: 'center',

  [theme.breakpoints.up('md')]: {
    justifyContent: 'left',
  },
}));

export const ImageFrame = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.spacing(3),
  display: 'inline-block',
  backgroundColor: 'white',
  boxShadow:
    ' -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)',
}));

export const StyledImage = styled(Box)(({ theme }) => ({
  display: 'block',
  width: 320,
  height: 420,
  objectFit: 'cover',
  borderRadius: theme.spacing(2.5),
  [theme.breakpoints.up('sm')]: {
    width: 380,
    height: 470,
  },
  [theme.breakpoints.up('md')]: {
    width: 500,
    height: 700,
    objectFit: 'cover',
    maxWidth: '500px',
    maxHeight: '700px',
  },
}));

export const SectionTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  fontFamily: 'Gotham',
  textAlign: 'left',
  [theme.breakpoints.down('1060')]: {
    fontSize: '40px',
    lineHeight: '48px',
  },
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    letterSpacing: figmaLetterSpacing(40, -1),
    marginTop: '50px !important',
    fontSize: '40px',
    lineHeight: '44px',
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '25px',
    padding: '0 16px',
  },
}));

export const pillStyles = {
  fontSize: { xs: '16px', md: '18px' },
};
